import { useCallback, useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

interface ILineChartProps {
	chartData: any;
	chartOptions: any;
	width?: number | string;
	height?: number | string;
}

const LineChart = ({
	width = '100%',
	height = '300px',
	...props
}: ILineChartProps) => {
	const [options, setOptions] = useState({});
	const [series, setSeries] = useState([]);
	const [chartKey, setChartKey] = useState(0);
	const containerRef = useRef<HTMLDivElement>(null);
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	const forceResize = useCallback(() => {
		if (timeoutRef.current) clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(
			() => setChartKey(prev => prev + 1),
			150
		);
	}, []);

	useEffect(() => {
		setOptions(props?.chartOptions);
		setSeries(props?.chartData);
	}, [props?.chartData, props?.chartOptions]);

	useEffect(() => {
		if (!containerRef.current) return;

		const resizeObserver = new ResizeObserver(forceResize);
		resizeObserver.observe(containerRef.current);

		const handleResize = () => forceResize();
		window.addEventListener('resize', handleResize);

		return () => {
			resizeObserver.disconnect();
			window.removeEventListener('resize', handleResize);
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
		};
	}, [forceResize]);

	return (
		<div
			ref={containerRef}
			style={{ width: '100%' }}
		>
			<ReactApexChart
				key={chartKey}
				options={options}
				series={series}
				type='line'
				width={width}
				height={height}
			/>
		</div>
	);
};

export default LineChart;
